export enum PasswordStrengthEnum {
  NONE = "none",
  WEAK = "weak",
  MEDIUM = "medium",
  STRONG = "strong"
}
export interface PasswordStrengthProps {
  hasMinCharacters: boolean;
  hasMinNumbers: boolean;
  hasMinLowercaseLetters: boolean;
  passwordStrengthValue: PasswordStrengthEnum;
}
